export function CareerModel() {
    const model = {
        medicalBook: true,
        salaryShow: true,
        salaryRequired: false,
        schedule: {
            show: true,
            custom: false,
            saveCustom: false,
            variants: [],
        },
        workStartShow: true,
        workStartRequired: false,
    };

    return {
        data: model,
        update(fieldData) {
            if (!fieldData) return;
            const data = fieldData.career;
            if (!data) return;

            ["medicalBook", "salaryShow", "salaryRequired", "workStartShow", "workStartRequired"].forEach((key) => {
                model[key] = data[key];
            });

            ["show", "custom", "saveCustom"].forEach((key) => {
                model.schedule[key] = data.schedule[key];
            });
        },
        reset() {
            ["medicalBook", "salaryShow", "workStartShow"].forEach((key) => {
                model[key] = true;
            });

            ["salaryRequired", "workStartRequired"].forEach((key) => {
                model[key] = false;
            });

            model.schedule.show = true;

            ["custom", "saveCustom"].forEach((key) => {
                model.schedule[key] = false;
            });
        },
        setDictionaries(dictionaries) {
            const { schedule } = dictionaries;

            if (schedule) model.schedule.variants = schedule;
        },
        getDictionaries() {
            const { schedule } = model;
            return {
                schedule: schedule.variants,
            };
        },
        getData() {
            return {
                career: model,
            };
        },
    };
}
